import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

interface UpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpgrade: () => void;
  resourceKey?: 'brands' | 'personas' | 'users';
}

export const UpgradeModal: React.FC<UpgradeModalProps> = ({ isOpen, onClose, onUpgrade, resourceKey = 'brands' }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const singular = t(`billing.features.${resourceKey}`, { count: 1 });
  const plural = t(`billing.features.${resourceKey}`, { count: 2 });

  return (
    <div className="fixed inset-0 z-[70]">
      <div className="absolute inset-0 bg-black bg-opacity-60" onClick={onClose} />
      <div className="relative z-[71] min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-2xl border-[3px] border-black shadow-2xl w-full max-w-xl p-6">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>

          <div className="mb-4">
            <h2 className="text-2xl font-extrabold text-gray-900">
              {t('upgradeModal.title', 'Congrats, you have reached your limit 🥳')}
            </h2>
            <p className="text-gray-800 text-sm mt-2">
              {t('upgradeModal.description', { singular, plural, defaultValue: 'You want to get more you can delete a {{singular}} or upgrade now to get more {{plural}}.' })}
            </p>
          </div>

          <div className="flex justify-end">
            <button
              onClick={onUpgrade}
              className="inline-flex items-center px-5 py-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
              {t('upgradeModal.cta', 'Upgrade now')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


